import { render, staticRenderFns } from "./Etapa2.vue?vue&type=template&id=542a0b1e&scoped=true"
import script from "./Etapa2.vue?vue&type=script&lang=js"
export * from "./Etapa2.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=542a0b1e&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa2.vue?vue&type=style&index=1&id=542a0b1e&prod&scoped=true&lang=scss"
import style2 from "./Etapa2.vue?vue&type=style&index=2&id=542a0b1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a0b1e",
  null
  
)

export default component.exports